export type CustomBenchmark = {
  indicator_name: string;
  name: string;
  low_value?: number;
  moderate_value?: number;
  high_value?: number;
  notes?: string;
};

export type CustomBenchmarkSuccessResponse = CustomBenchmark & {
  id: string;
  created_at: string;
  modified_at: string;
};

export const CUSTOM_BENCHMARK_COLLECTION_PATH = 'organization/{organization_id}/custom-benchmarks/';
export const CUSTOM_BENCHMARK_DETAIL_PATH = 'organization/{organization_id}/custom-benchmarks/{pk}/';
/**
 * POST /api/v1/organization/{organization_id}/custom-benchmarks/
 */
export const POST_CUSTOM_BENCHMARK_PATH = CUSTOM_BENCHMARK_COLLECTION_PATH;
export type PostCustomBenchmarkRequestPathVariables = { organization_id: string };
export type PostCustomBenchmarkRequestQueryParams = undefined;
export type PostCustomBenchmarkRequestBodyData = CustomBenchmark;
export type PostCustomBenchmarkSuccessDto = CustomBenchmarkSuccessResponse;
export type PostCustomBenchmarkErrorDto = Error;

/**
 * GET /api/v1/organization/{organization_id}/custom-benchmarks/
 */
export const GET_CUSTOM_BENCHMARK_PATH = CUSTOM_BENCHMARK_COLLECTION_PATH;
export type GetCustomBenchmarksRequestPathVariables = { organization_id: string };
export type GetCustomBenchmarksRequestQueryParams = { indicator_name?: string };
export type GetCustomBenchmarksSuccessDto = {
  count: number;
  next: string | null;
  previous: string | null;
  results: CustomBenchmarkSuccessResponse[];
};
export type GetCustomBenchmarksErrorDto = Error;

/**
 * PATCH /api/v1/organization/{organization_id}/custom-benchmarks/{pk}/
 */
export const PATCH_CUSTOM_BENCHMARK_PATH = CUSTOM_BENCHMARK_DETAIL_PATH;
export type PatchCustomBenchmarkRequestPathVariables = { organization_id: string; pk: string };
export type PatchCustomBenchmarkRequestQueryParams = undefined;
export type PatchCustomBenchmarkRequestBodyData = Partial<CustomBenchmark>;
export type PatchCustomBenchmarkSuccessDto = CustomBenchmarkSuccessResponse;
export type PatchCustomBenchmarkErrorDto = Error;

/**
 * DELETE /api/v1/organization/{organization_id}/custom-benchmarks/{pk}/
 */
export const DELETE_CUSTOM_BENCHMARK_PATH = CUSTOM_BENCHMARK_DETAIL_PATH;
export type DeleteCustomBenchmarkRequestPathVariables = { organization_id: string; pk: string };
export type DeleteCustomBenchmarkRequestQueryParams = undefined;
export type DeleteCustomBenchmarkRequestBodyData = undefined;
export type DeleteCustomBenchmarkSuccessDto = undefined;
export type DeleteCustomBenchmarkErrorDto = Error;

export enum CustomBenchmarkType {
  SCIENTIFIC = 'scientific',
}

export type CustomBenchmarkProps = {
  activeCustomBenchmark?: Partial<CustomBenchmark> | null;
  isScientific?: boolean;
};
